var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { encountersService } from 'ziphy-web-shared/basic/api';
import { getPatientGroupType, } from 'ziphy-web-shared/basic/entities/appointments';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { $loader } from 'ziphy-web-shared/basic/utils';
import clientService from '@services/client';
import styles from './BeforeSignErrors.module.scss';
const loaderId = 'before-sign-error-button';
const BeforeSignErrors = ({ appointment, encounter, errors, active, className }) => {
    const { t } = useTranslation();
    let content;
    if (errors.has('can_not_signing')) {
        content = t('text.sign_notes.before_sign.can_not_signing');
    }
    else if (errors.has('encounter_cancelled')) {
        content = t('text.sign_notes.before_sign.encounter_cancelled');
    }
    else if (errors.has('encounter_not_finished')) {
        content = (_jsxs(_Fragment, { children: [t('text.sign_notes.before_sign.encounter_not_finished'), ' ', _jsx(Button, Object.assign({ mode: ['anchor-gray-underline'], onClick: $loader.registerHandler(loaderId, () => __awaiter(void 0, void 0, void 0, function* () {
                        var _a;
                        return ((_a = getPatientGroupType(appointment)) === null || _a === void 0 ? void 0 : _a.code) === 'individual'
                            ? (yield clientService.finishAppointment({
                                id: encounter.appointmentId,
                            }))
                            : yield encountersService.finish({ id: encounter.id });
                    })), isLoading: $loader.isRunHandler(loaderId), className: styles.button }, { children: t('btn.finish_encounter') }))] }));
    }
    if (!content) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ className: classNames(styles.error, active && styles.active, className) }, { children: content })));
};
export default observer(BeforeSignErrors);
